import { Route, Routes } from "react-router-dom";
import { settingsSubrouteContent } from "@/components/navigation/adminSubRoutes";

export default function Adminsettings() {
  return (
    <>
      <Routes>
        {settingsSubrouteContent.map((content: any) => (
          <Route
            path={content.path}
            element={content.element}
            key={content.path}
          />
        ))}
      </Routes>
    </>
  );
}
